import { SafeAreaView } from 'react-native-safe-area-context'
import { View } from 'react-native'
import { Logo } from '@/src/assets/icons/Logo'
import { mesaColorNames } from '@/src/common/theme'
import { Spinner } from 'tamagui'
import type { ComponentProps } from 'react'

export function LoadingScreen({ style }: Pick<ComponentProps<typeof SafeAreaView>, 'style'>) {
  return (
    <SafeAreaView
      style={[
        {
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          paddingHorizontal: 12,
          backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
        },
        style,
      ]}
    >
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          marginTop: 32,
        }}
      >
        <Logo />
      </View>

      <View style={{ marginTop: 48 }}>
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment -- nondeterministic type complexity */}
        {/* @ts-ignore super weird.. this happens here but not anywhere else */}
        <Spinner color={mesaColorNames['Greyscale/500 #6E7375']} scale={1.5} />
      </View>
    </SafeAreaView>
  )
}
